import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
// import tableVodCatalog from './tableVodTemplateCatalog';
import OutpuServersFields from './formGroup20OutputServerFields';
export default {
  title: 'Video Outputs',
  attributeName: 'liveCamerasOutputs',
  fields: [
    {
      attributeName: 'videoOutputs',
      type: FormInputTypes.JSON_COMPONENT,
      canCreate:false,
      canRemove:false,
      emptyMessage: "You don't have any video output yet.",
      columns:1,
      label: 'Video Outputs',
      itemLabel:'Video Output',
      required: true,
      helpText: 'Insert new video outputs clicking in + button.',
      errorText: '',
      extraValues:['deploymentType'],
      popupFormGroups:[
        OutpuServersFields
      ]
    },
  ]
  
};
